// @flow
import _ from 'lodash';

export default class RentFeeOwner {
  campaign: string;
  homieFirstFee: number;
  homieMonthlyFee: number;

  constructor(data: any = {}) {
    this.campaign = _.get(data, 'marketing_campaign.campaign', null);
    this.homieFirstFee = this.getHomieFee(
      data,
      'marketing_campaign.rent_fee_for_owner.homie_first_fee',
      'homie_first_fee',
      0
    );
    this.homieMonthlyFee = this.getHomieFee(
      data,
      'marketing_campaign.rent_fee_for_owner.homie_monthly_fee',
      'homie_monthly_fee',
      0.09
    );
  }

  getHomieFee = (data, firstPath, secondPath, defaultValue) => {
    let homieFee = _.get(data, secondPath, defaultValue);
    return _.get(data, firstPath, homieFee);
  };
}
